import React, { useCallback, useEffect, useState } from 'react';
import { HttpStatus } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, trigger } from '@philips-internal/oswald-ui-utils';
import { useRouterContext } from '../../hooks/use-router-context.js';
import './inline-image.css';
function isSVGURL(src) {
    return src.endsWith('.svg');
}
function Image(props) {
    const { className, imageAlt, imageStyle, onClick, preventContextMenu, src, style } = props;
    const [href, setTarget] = useRouterContext(src);
    const [content, setContent] = useState(null);
    const wrapperClassname = classNames({
        'c-inline-image': true,
        [`${className}`]: Boolean(className),
    });
    useEffect(() => {
        if (isSVGURL(href)) {
            void fetch(href)
                .then((response) => {
                if (response.status !== HttpStatus.OK) {
                    return null;
                }
                return response.text();
            })
                .then((text) => setContent(text));
        }
        else {
            setContent(null);
        }
    }, [href]);
    useEffect(() => {
        setTarget(src);
    }, [src]);
    const onImageContextMenuClick = useCallback((event) => {
        if (!preventContextMenu) {
            return;
        }
        event.preventDefault();
    }, [preventContextMenu]);
    const imgClassName = classNames({
        'c-inline-image__img': Boolean(preventContextMenu),
    });
    if (!isSVGURL(href)) {
        return (React.createElement("div", { className: wrapperClassname, onClick: trigger(onClick), style: style },
            React.createElement("img", { alt: imageAlt, className: imgClassName, onContextMenu: onImageContextMenuClick, src: href, style: imageStyle })));
    }
    if (!content) {
        return null;
    }
    return (React.createElement("div", { className: wrapperClassname, dangerouslySetInnerHTML: { __html: content }, onClick: trigger(onClick), style: style }));
}
export { Image, };
//# sourceMappingURL=image.js.map